import { createSelector } from '@reduxjs/toolkit';
import { selectChainsReportTotalCount } from '../chains-report-chains-selectors-factory';

export const selectChainsReportHasChains = createSelector(
    selectChainsReportTotalCount,
    (total) => total > 0,
);
